<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">Purchase Shopify Licence</h4>
    </div>
    <div class="modal-body">
      <!-- Product -->
      <div>
        <label>Product</label>
        <div class="form-group mb-3">
          <input type="text" name="product" [ngModel]="purchase.title" [disabled]="true" class="form-control" autocomplete="off" required />
        </div>
      </div>

      <!-- Licence Key -->
      <div *ngIf="purchase.existingLicenceKey">
        <label>Licence Key</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="licence-key"
            [ngModel]="purchase.existingLicenceKey"
            [disabled]="true"
            class="form-control"
            autocomplete="off"
            required
          />
        </div>
      </div>

      <!-- Customer -->
      <div>
        <label>E-Mail address</label>
        <div class="form-group mb-3">
          <input
            type="email"
            name="mail"
            [(ngModel)]="purchase.recipient"
            class="form-control"
            [class.is-invalid]="purchase.recipient !== '' && !isValidMail"
            autocomplete="off"
            required
          />
        </div>
      </div>
      <div>
        <label>First name</label>
        <div class="form-group mb-3">
          <input type="text" name="first-name" [(ngModel)]="purchase.firstName" class="form-control" autocomplete="off" required />
        </div>
      </div>
      <div>
        <label>Last name</label>
        <div class="form-group mb-3">
          <input type="text" name="last-name" [(ngModel)]="purchase.lastName" class="form-control" autocomplete="off" required />
        </div>
      </div>

      <!-- Template Language -->
      <div>
        <label>Mail Language</label>
        <div class="form-group mb-3">
          <select class="form-select" name="language" [(ngModel)]="purchase.language" required>
            <option ngValue="de">de</option>
            <option ngValue="en">en</option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-success" [disabled]="!f.form.valid || !isValid">Submit</button>
    </div>
  </form>
</div>
